import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

// Allow typing slashes or dashes
const PARSE_DELIMITERS = /[-/]/;

// Always use dashes for formatting
const FORMAT_DELIMITER = '-';

const REQUIRED_DATE_LENGTH_WITHOUT_DELIMITERS = 8;

@Injectable({
  providedIn: 'root'
})
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    if (value) {
      value = value.trim();

      const hasDelimiters = PARSE_DELIMITERS.test(value);

      const dateStruct = hasDelimiters ? this.parseDateWithDelimiters(value) : this.parseDateWithoutDelimiters(value);

      if (dateStruct?.year > 1000) {
        return dateStruct;
      }
    }

    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? `${this.zeroPad(date.month, 2)}${FORMAT_DELIMITER}${this.zeroPad(date.day, 2)}${FORMAT_DELIMITER}${this.zeroPad(date.year, 4)}`
      : '';
  }

  private parseDateWithDelimiters(value: string): NgbDateStruct | null {
    const date = value.split(PARSE_DELIMITERS);

    // Assuming MM-DD-YYYY format
    const year = parseInt(date[2], 10);
    const month = parseInt(date[0], 10);
    const day = parseInt(date[1], 10);

    return { year, month, day };
  }

  private parseDateWithoutDelimiters(value: string): NgbDateStruct | null {
    if (value.length === REQUIRED_DATE_LENGTH_WITHOUT_DELIMITERS) {
      // Assuming MM-DD-YYYY format
      const year = parseInt(value.substring(4), 10);
      const month = parseInt(value.substring(0, 2), 10);
      const day = parseInt(value.substring(2, 4), 10);

      return { year, month, day };
    }

    return null;
  }

  private zeroPad(s: string | number, maxLength: number) {
    return String(s).padStart(maxLength, '0');
  }
}
